import styles from "./DotsTypingLoader.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const DotsAnimationLoader = () => (
  <div className={styles.bouncingDots}>
    {new Array(3).fill("").map((_val, index) => (
      <div key={index} className={styles.dot} />
    ))}
  </div>
);

export default wrapperHOC(DotsAnimationLoader, {
  componentName: "DotsAnimationLoader-Global",
  showForChina: true,
});
